import { storyCards } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function StoryGrid() {
  return (
    <section className="border-b border-background-200 bg-background-50 scroll-mt-32">
      <div className="px-4 md:px-6 py-8 md:py-12">
        <SectionHeading
          id="stories"
          index="05"
          title="新料速览"
          subtitle="封面驱动的高密度卡片，一眼扫过今天还没看过的瓜"
          actionText="加载更多新料"
        />

        <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {storyCards.map((card) => (
            <article
              key={card.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100"
            >
              <div className="relative w-full h-[200px] md:h-[220px] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={`黑料网曝新料 ${card.title}`}
                  title={`黑料网曝快讯 ${card.title}`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 rounded-md bg-background-50/90 px-2.5 py-1 text-xs text-foreground-800">
                  {card.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h4 className="font-heading text-base md:text-lg font-bold leading-snug text-foreground-900 transition-colors group-hover:text-primary-600 hlwp-clamp-2">
                  {card.title}
                </h4>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600 hlwp-clamp-2">
                  {card.excerpt}
                </p>
                <div className="mt-auto flex items-center justify-between gap-3 border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-time-line"></i>
                    {card.time}
                  </span>
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-900">
                    {card.source}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}